export enum EnumRequestType {
  Json,
  FormUrlEncoder,
  NoAuthJson,
  FormData,
}
